import { useNuxtApp } from "#app";
import { BaseService } from "../base/base.service";
import {
  ModelCheckQuota,
  type IModelCheckQuotaResponse,
} from "./dto/quota.dto";
import { QuotaRepository } from "./quota.repository";

export class QuotaService extends BaseService {
  private quotaRepository = new QuotaRepository(this.api, this.configService);

  async checkQuota(params: any): Promise<ModelCheckQuota> {
    const { $functions } = useNuxtApp();
    let dataResult = new ModelCheckQuota();

    try {
      const res = await this.quotaRepository.checkQuota(params);
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        dataResult = new ModelCheckQuota(resData.data);
        console.log("checkQuota", params, resData.data, dataResult);
      }
    } catch (err: any) {
      $functions.notify.error({
        text: err.message,
      });
      console.log(err, QuotaService.name);
    }

    return dataResult;
  }
}